// client/src/services/campaignEmailApi.js
// Email as a marketing-campaign channel (On-Screen 2.0).

import { getJson, postJson } from './http';

const base = (tenantId) => `/api/tenants/${Number(tenantId)}`;

export const listCampaignEmails = (tenantId, campaignId) =>
  getJson(`${base(tenantId)}/campaigns/${Number(campaignId)}/emails`);

export const getCampaignEmail = (tenantId, id) =>
  getJson(`${base(tenantId)}/campaign-emails/${Number(id)}`);

export const previewAudience = (tenantId, campaignId, audience) =>
  postJson(`${base(tenantId)}/campaigns/${Number(campaignId)}/emails/preview-audience`, { audience });

export const createCampaignEmail = (tenantId, campaignId, payload) =>
  postJson(`${base(tenantId)}/campaigns/${Number(campaignId)}/emails`, payload);

export const queueCampaignEmail = (tenantId, id, scheduledAt) =>
  postJson(`${base(tenantId)}/campaign-emails/${Number(id)}/send`, scheduledAt ? { scheduledAt } : {});

export const testCampaignEmail = (tenantId, id, to) =>
  postJson(`${base(tenantId)}/campaign-emails/${Number(id)}/test`, to ? { to } : {});

export const EMAIL_AUDIENCES = [
  { value: 'members', label: 'All members', needsEvent: false },
  { value: 'event_registrants', label: 'Everyone registered for an event', needsEvent: true },
  { value: 'ticket_buyers', label: 'Ticket buyers for an event', needsEvent: true },
  { value: 'all_ticket_buyers', label: 'All ticket buyers (any event)', needsEvent: false },
];

export const EMAIL_STATUS_LABELS = {
  draft: 'Draft', scheduled: 'Scheduled', sending: 'Sending', paused: 'Paused', sent: 'Sent',
};
